import React from "react";

const MpFieldRow = ({ label, children }) => (
  <div className="partner-details-overview__row">
    <div className="partner-details-overview__label">{label}</div>
    <div className="partner-details-overview__value">{children}</div>
  </div>
);

export default MpFieldRow;
